//学历
export const eduList = ['初中', '高中', '大专', '本科','硕士','博士']
//经验要求
export const expList = ['1年以内', '1-3年', '3-5年', '5年以上']

// 公司规模
export const scaleList = ['2-10人', '11-20人', '21-50人', '51-100人','101-200人','200人以上']

export const salaryTypeList = ['日结','周结','半月结','月结','项目结']


// 生成包含数字1到270的数组的方法
const generateNumberArray = (start, end) => {
  const result = [];
  for (let i = start; i <= end; i++) {
    result.push({ label: `${i}k`, value: i });
  }
  return result;
};

// 导出生成的数组
export const minArray = generateNumberArray(1, 250);
export const maxArray = generateNumberArray(1, 270);

